import React from "react";
import VideoYoutube from "../../shared/components/VideoYoutube/VideoYoutube";
import "./Videos.css";

const Videos = () => {
  const matchResult = window.matchMedia("(max-width:575px)").matches;

  return (
    <div className="videos-container  p-5" id="videos">
      <div className="container  d-flex justify-content-center">
        <div className="container-titulo-video">
          <h2 className="text-center text-white titulo-video">Vídeos Aéreos</h2>
        </div>
      </div>
      <div
        className={`container p-5 ${
          !matchResult ? "" : "d-flex justify-content-center"
        }`}
      >
        <div className="row ml-lg-3 ml-0">
          <div className="col-lg-4 col-12">
            <VideoYoutube youtubeId={"UmQuvQG9o-g"} mobile={matchResult} />
          </div>
          <div className="col-lg-4 col-12">
            <VideoYoutube youtubeId={"Olb7Jij0fOA"} mobile={matchResult} />
          </div>
          <div className="col-lg-4 col-12">
            <VideoYoutube youtubeId={"KnRHFKATTXY"} mobile={matchResult} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Videos;
